
const UrlApi = {
  // local
  baseUrl: "https://api.boxedandgolb.com/admin/",
  baseUrlImage: "https://api.boxedandgolb.com/uploads/",
  // auth
  auth: {
    login: "auth/login",
    autologin: "auth/autologin",
    signup: "auth/signup",
    logout: "auth/logout",
    forgotPassword: "auth/forgot-password",
    resetPassword: "auth/reset-password",
  },
  admins: {
    get: "admins/get",
    add: "admins/add",
    edit: "admins/edit",
    delete: "admins/delete",
    getUserType: "admins/get_user_type",
    getUserPrivilegs: "admins/privileg",
    addUserPrivilegs: "admins/addprivileg",
    editUserPrivilegs: "admins/editprivileg",
    deleteprivileg: "admins/deleteprivileg",
  },

  admins_logs: {
    get: "admins_logs/get",
    edit: "admins_logs/edit"
  },

  how_it_works: {
    get: "how_it_works/get",
    add: "how_it_works/add",
    edit: "how_it_works/edit",
    delete: "how_it_works/delete",
  },

  slideshow: {
    get: "slideshow/get",
    add: "slideshow/add",
    edit: "slideshow/edit",
    delete: "slideshow/delete",
  },

  faqs: {
    get: "faqs/get",
    add: "faqs/add",
    edit: "faqs/edit",
    delete: "faqs/delete",
  },

  features: {
    get: "features/get",
    add: "features/add",
    edit: "features/edit",
    delete: "features/delete",
  },

  settings: {
    get: "settings/get",
    edit: "settings/edit"
  },

  contact_info: {
    get: "contact_info/get",
    add: "contact_info/add",
    edit: "contact_info/edit",
    delete: "contact_info/delete",
  },

  legalInformation: {
    get: "settings/get",
    edit: "settings/edit",
  },

  services: {
    get: "services/get",
    edit: "services/edit",
    add: "services/add",
    delete: "services/delete",
  },

  services_image: {
    get: "services_image/get",
    edit: "services_image/edit",
    add: "services_image/add",
    delete: "services_image/delete",
  },

  messages: {
    get: "messages/get",
    delete: "messages/delete",
  }
};

export default UrlApi;
